<template>
    <bottom-dialog v-model="showDialog" :dialog="true" max-width="550px">
        <v-card flat tile>
            <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                {{$translate('Message')}}
                <v-spacer />
                <v-btn icon @click="showDialog = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="mt-4">
                <div v-if="type == 'user'" class="mb-4">
                    {{$translate('Send a message to {0}').format(post.name)}}
                </div>
                <div v-if="type == 'team'" class="mb-4">
                    {{$translate('Send a message to discuss joining {0}').format(post.group.name)}}
                </div>
                <div v-if="type == 'usergrouprequest'" class="mb-4">
                    {{$translate('Send a message to {0}').format(post.user.name)}}
                </div>

                <FormField :field="messageField" v-model="changed.message" />

                <div v-if="type == 'user' && isTeamLeader">
                    <FormField :field="teamField" v-model="changed.group_id" />
                </div>
            </v-card-text>

            <v-card-actions>
                <v-radio-group v-model="changed.action" row v-if="type == 'usergrouprequest'">
                    <v-radio :label="$translate('Accept')" value="accept"></v-radio>
                    <v-radio :label="$translate('Decline')" value="decline"></v-radio>
                </v-radio-group>

                <v-spacer></v-spacer>
                <v-btn color="primary" @click="send" :loading="sending" :disabled="!canSend">{{$translate('Send')}}</v-btn>
            </v-card-actions>
        </v-card>
    </bottom-dialog>
</template>

<script>
import BottomDialog from '../components/BottomDialog.vue';
import FormField from '../components/FormField.vue';
export default {
    name: 'zoezi-teamsport-player-pool-team-post-dialog',
    props: {
        value: {
            type: Boolean
        },
        type: {
            type: String // user, team or usergrouprequest
        },
        post: {
            type: Object
        },
        groups: {
            type: Array
        }
    },

    components: {
        BottomDialog,
        FormField
    },

    watch: {
        value: {
            immediate: true,
            handler(show) {
                if (show) {
                    this.changed.message = '';
                    this.changed.group_id = null;
                    this.changed.action = null;
                }
            }
        }
    },

    data: () => ({
        changed: {
            message: '',
            action: null,
            group_id: null
        },
        sending: false
    }),

    computed: {
        messageField() {
            return {
                title: 'Message',
                type: 'textarea'
            }
        },
        teamField() {
            return {
                type: 'select',
                title: 'Invite to team',
                hint: 'Leave blank to send message without invitation',
                placeholder: 'Choose team',
                data: this.groups?.map(group => {
                    return {
                        text: group.name,
                        value: group.id
                    }
                })
            }
        },
        showDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        canSend() {
            return this.changed.message;
        },
        isTeamLeader() {
            return this.groups?.length > 0;
        }
    },
    methods: {
        possiblyShowError(response) {
            if (!response.ok) {
                response.json().then(data => {
                    this.$store.commit('showErrorDialog', { title: this.$translate('Error'), text: `${this.$translate('Something went wrong')}. ${this.$translate(data?.message)}`});
                });
            }
        },
        send() {
            this.sending = true;
            if (this.type == 'usergrouprequest') {
                const data = {
                    request_id: this.post.id,
                    action: this.changed.action == 'accept' ? true : (this.changed.action == 'decline' ? false : null),
                    message: this.changed.message
                }

                this.$api.post('/api/memberapi/usergroup/request/reply', null, data).then(response => {
                    this.sending = false;
                    if (response.ok) {
                        this.showDialog = false
                    }
                    this.possiblyShowError(response)
                })
            } else if (this.type == 'team') {
                const data = {
                    ppt_id: this.post.id,
                    comment: this.changed.message
                }

                this.$api.post('/api/memberapi/usergroup/request/add', null, data).then(response => {
                    this.sending = false;
                    if (response.ok) {
                        this.showDialog = false
                    }
                    this.possiblyShowError(response)
                })
            } else if (this.type == 'user') {
                if (this.changed.group_id) {
                    const data = {
                        recipient_id: this.post.user_id,
                        group_id: this.changed.group_id,
                        message: this.changed.message
                    }
                    this.$api.post('/api/memberapi/group/invite', data).then(response => {
                        this.sending = false;
                        if (response.ok) {
                            this.showDialog = false
                        }
                        this.possiblyShowError(response)
                    })
                } else {
                    const data = {
                        playerpooluser_id: this.post.id,
                        message: this.changed.message
                    }
                    this.$api.post('/api/playerpooluser/send_mail', data).then(response => {
                        this.sending = false;
                        if (response.ok) {
                            this.showDialog = false
                        }
                        this.possiblyShowError(response)
                    })
                }
            }
        }
    }
}
</script>
